import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { FaEye, FaEyeSlash } from "react-icons/fa";

export default function Login() {
    const [email, setEmail]     = useState('');
    const [senha, setSenha]     = useState('');
    const [erro, setErro]       = useState('');
    const [mostrarSenha, setMostrarSenha] = useState(false);
    const [loading, setLoading] = useState(false);
    const { login }             = useAuth();
    const navigate              = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErro('');
        setLoading(true);
        try {
            await login(email, senha);
            navigate('/');
        } catch (err) {
            setErro(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{
            minHeight:      '100vh',
            display:        'flex',
            alignItems:     'center',
            justifyContent: 'center',
            background:     '#F2F3F4',
        }}>
            <div style={{
                background:   '#fff',
                borderRadius: '12px',
                padding:      '48px 40px',
                width:        '100%',
                maxWidth:     '400px',
                boxShadow:    '0 4px 24px rgba(0,0,0,0.08)',
            }}>
                <div style={{ textAlign: 'center', marginBottom: '32px' }}>
                    <div style={{ fontSize: '32px', marginBottom: '8px' }}>🏛</div>
                    <h1 style={{ margin: 0, fontSize: '22px', color: '#1B2631' }}>
                        Coliseum Leilões
                    </h1>
                    <p style={{ color: '#7F8C8D', margin: '4px 0 0', fontSize: '14px' }}>
                        Painel Administrativo
                    </p>
                </div>

                <form onSubmit={handleSubmit}>
                    <div style={{ marginBottom: '16px' }}>
                        <label style={labelStyle}>E-mail</label>
                        <input
                            type="email"
                            value={email}
                            onChange={e => setEmail(e.target.value)}
                            required
                            autoFocus
                            style={inputStyle}
                            placeholder="seu@email.com"
                        />
                    </div>

                    <div style={{ marginBottom: '24px' }}>
                        <label style={labelStyle}>Senha</label>
                        <div style={{ position: 'relative' }}>
                        <input
                            type={mostrarSenha ? 'text' : 'password'}
                            value={senha}
                            onChange={(e) => setSenha(e.target.value)}
                            autoComplete="current-password"
                            style={{
                                width: '100%',
                                padding: '10px 45px 10px 10px'
                            }}
                        />

                        <button
                            type="button"
                            onClick={() => setMostrarSenha(!mostrarSenha)}
                            style={{
                                position: 'absolute',
                                right: '10px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                background: 'transparent',
                                border: 'none',
                                cursor: 'pointer',
                                fontSize: '18px'
                            }}
                            aria-label={mostrarSenha ? 'Ocultar senha' : 'Mostrar senha'}
                        >
                            {mostrarSenha ? <FaEyeSlash /> : <FaEye />}
                        </button>
                    </div>
                    </div>

                    {erro && (
                        <div style={{
                            background:   '#FDEDEC',
                            color:        '#922B21',
                            padding:      '10px 14px',
                            borderRadius: '6px',
                            fontSize:     '14px',
                            marginBottom: '16px',
                        }}>
                            {erro}
                        </div>
                    )}

                    <button
                        type="submit"
                        disabled={loading}
                        style={{
                            width:        '100%',
                            padding:      '12px',
                            background:   loading ? '#AED6F1' : '#1B4F72',
                            color:        '#fff',
                            border:       'none',
                            borderRadius: '8px',
                            fontSize:     '15px',
                            fontWeight:   '600',
                            cursor:       loading ? 'not-allowed' : 'pointer',
                        }}
                    >
                        {loading ? 'Entrando...' : 'Entrar'}
                    </button>
                </form>
            </div>
        </div>
    );
}

const labelStyle = {
    display:      'block',
    fontSize:     '13px',
    fontWeight:   '600',
    color:        '#2C3E50',
    marginBottom: '6px',
};

const inputStyle = {
    width:        '100%',
    padding:      '10px 12px',
    border:       '1px solid #D5D8DC',
    borderRadius: '6px',
    fontSize:     '14px',
    boxSizing:    'border-box',
    outline:      'none',
};
